import { useState } from 'react'
import BountyModal from './BountyModal/BountyModal'
import BountyContent from './BountyContent/BountyContent'
import { BountyStatusType } from '@src/context/BountiesContext'

export interface BountyItemProps {
  bountyId: number
  bgImageUrl?: string | null
  title: string
  rating: number
  subtitle: string
  buttonText?: string
  disabled: boolean
  status: BountyStatusType
  expires: string | null
  showOnlyInfo: boolean
  availableBountiesCount: number | null
}

export type ModalType = 'grab' | 'info' | null

const Bounty = ({
  bountyId,
  bgImageUrl = '',
  title,
  rating,
  subtitle,
  disabled,
  status,
  expires,
  buttonText,
  showOnlyInfo = false,
  availableBountiesCount,
}: BountyItemProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalType, setModalType] = useState<ModalType>(null)

  const openModal = (type: ModalType) => {
    setModalType(type)
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setModalType(null)
  }

  const openInfoModal = () => {
    setModalType('info')
    setIsModalOpen(true)
  }

  const handleInfoClick = () => openModal('info')
  const handleGrabClick = () => openModal('grab')

  return (
    <>
      <div>
        <BountyContent
          buttonText={buttonText}
          bgImageUrl={bgImageUrl || ''}
          title={title}
          subtitle={subtitle}
          rating={rating}
          disabled={disabled}
          expires={expires}
          showOnlyInfo={showOnlyInfo}
          availableBountiesCount={availableBountiesCount}
          onInfoClick={handleInfoClick}
          onGrabClick={handleGrabClick}
          status={status}
        />
      </div>

      {modalType && (
        <BountyModal
          isOpen={isModalOpen}
          onClose={closeModal}
          bountyId={bountyId}
          type={modalType}
          openInfoModal={openInfoModal}
        />
      )}
    </>
  )
}

export default Bounty
